import React from "react";
import { Link } from "react-router-dom";
import { DiseaseCategoryWithDisease } from "../../../../../domain/disease_knowledge/DiseaseCategoryWithDisease";
import { DiseaseCategory } from "../DiseaseCategory";

export const DiseaseKnowledgeListItem = React.memo(function DiseaseKnowledgeListItem(props: Props) {
    const {
        category,
        openDetailDialogButton
    } = props;

    return (
        <li className={"disease_category"}>
            <h3 className={"disease_category_name"}>
                <DiseaseCategory categoryId={category.id} />
                {category.name}
            </h3>
            <ul>
                {category.diseases.map(disease => (
                    <li key={disease.id} className={"disease_name"}>
                        <Link to={"#"} onClick={openDetailDialogButton(disease.id)}>{disease.name}</Link>
                    </li>
                ))}
            </ul>
        </li>
    );
});

type Props = {
    category: DiseaseCategoryWithDisease
    openDetailDialogButton: (diseaseId: string) => () => void
};
